export default {
  GET_ALL_QUESTS_START: 'tasks/GET_ALL_QUESTS_START',
  GET_ALL_QUESTS_SUCCESS: 'tasks/GET_ALL_QUESTS_SUCCESS',
  GET_ALL_QUESTS_FAILURE: 'tasks/GET_ALL_QUESTS_FAILURE',

  ADD_QUEST_START: 'tasks/ADD_QUEST_START',
  ADD_QUEST_SUCCESS: 'tasks/ADD_QUEST_SUCCESS',
  ADD_QUEST_FAILURE: 'tasks/ADD_QUEST_FAILURE',

  UPDATE_QUEST_START: 'tasks/UPDATE_QUEST_START',
  UPDATE_QUEST_SUCCESS: 'tasks/UPDATE_QUEST_SUCCESS',
  UPDATE_QUEST_FAILURE: 'tasks/UPDATE_QUEST_FAILURE',

  DELETE_QUEST_START: 'tasks/DELETE_QUEST_START',
  DELETE_QUEST_SUCCESS: 'tasks/DELETE_QUEST_SUCCESS',
  DELETE_QUEST_FAILURE: 'tasks/DELETE_QUEST_FAILURE',

  ACCEPT_CHALLENGE_START: 'tasks/ACCEPT_CHALLENGE_START',
  ACCEPT_CHALLENGE_SUCCESS: 'tasks/ACCEPT_CHALLENGE_SUCCESS',
  ACCEPT_CHALLENGE_FAILURE: 'tasks/ACCEPT_CHALLENGE_FAILURE',

  UPDATE_CHALLENGE_START: 'tasks/UPDATE_CHALLENGE_START',
  UPDATE_CHALLENGE_SUCCESS: 'tasks/UPDATE_CHALLENGE_SUCCESS',
  UPDATE_CHALLENGE_FAILURE: 'tasks/UPDATE_CHALLENGE_FAILURE',

  DELETE_CHALLENGE_START: 'tasks/DELETE_CHALLENGE_START',
  DELETE_CHALLENGE_SUCCESS: 'tasks/DELETE_CHALLENGE_SUCCESS',
  DELETE_CHALLENGE_FAILURE: 'tasks/DELETE_CHALLENGE_FAILURE',
};
